import { apiClient } from '../client'

export interface GetAssetDataRequest {
  chainId: string
  denom: string
}

export interface GetAssetDataResponse {
  id: string
  symbol: string
  name: string
  platforms: Record<string, string>
  description: Record<string, string>
  links: {
    homepage: string[]
    whitepaper: string
    blockchain_site: string[]
    official_forum_url: string[]
    chat_url: string[]
    announcement_url: string[]
    snapshot_url?: string | null
    twitter_screen_name: string
    facebook_username: string
    bitcointalk_thread_identifier?: number | null
    telegram_channel_identifier: string
    subreddit_url: string
    repos_url: Record<string, string[]>
  }
  image: {
    thumb: string
    small: string
    large: string
  }
  market_data: {
    market_cap: Record<string, number>
    fully_diluted_valuation: Record<string, number>
    total_volume: Record<string, number>
    total_supply: number
    current_price: Record<string, number>
    price_change_percentage_24h: number
    price_change_24h: number
    last_updated: string
  }
  last_updated: string
}

export function getAssetData({
  chainId,
  denom,
}: GetAssetDataRequest): Promise<GetAssetDataResponse> {
  const searchParams = new URLSearchParams()
  searchParams.append('chain-id', chainId)
  searchParams.append('denom', denom)

  return apiClient
    .get('asset-data', {
      searchParams: searchParams.toString(),
      // Server side caching
      next: {
        // https://nextjs.org/docs/app/building-your-application/caching
        // https://nextjs.org/docs/app/api-reference/functions/fetch#optionsnextrevalidate
        revalidate: 60, // 1 minute since prices are involved
      },
    })
    .json()
}
